import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserSalesMessage } from 'app/services/sales.service';
import { MessageModalComponentViewModel } from './message-modal.viewmodel';
declare var $:any;

@Component({
	selector: 'message-modal',
	templateUrl: 'message-modal.html'
})
export class MessageModalComponent {

  @Input() viewModel: MessageModalComponentViewModel;

  postMessage() {
		this.viewModel.postMessage();
	}
	

	deleteMessage(messageId: number) {
		this.viewModel.deleteMessage(messageId);
	}

	putMessage(message: UserSalesMessage) {
		this.viewModel.putMessage(message);
	}
}


// WEBPACK FOOTER //
// ./src/app/containers/user/modal/message-modal.ts